import React, { useEffect, useState } from "react";
import styles from "./CaseStudiesCard.module.css";
import { useNavigate } from "react-router-dom";
import { InlineShareButtons } from "sharethis-reactjs";
import { APP_BASE_URL } from "configs/AppConfig";
import SocialShareIcons from "./SocialShareIcons";
import { Helmet } from "react-helmet";

function CaseStudiesCard({ item }) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Load ShareThis buttons
    if (window.__sharethis__) {
      window.__sharethis__.initialize();
    }
  }, []);

  return (
    <div className={styles.cardOuter} data-aos="fade-right" data-aos-delay="200">
      <img className={styles.firstImage} src={item.image} />
      <div className={styles.contents}>
        {/* <div className="sharethis-inline-share-buttons"></div> */}
        <SocialShareIcons
          shareUrl={`${window.location.href}/${item.slug}`}
          title={item.name}
          description={item?.metadescription}
          image = {item?.image}
        />
        <h2>{item.name}</h2>
        <p dangerouslySetInnerHTML={{ __html: item?.homeDescription }}></p>
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={styles.readMore}
          onClick={() => navigate(`/case-studies/${item.slug}`)}
        >
          <h3 className={styles.readH3}>Read More</h3>
          <img
            src={
              !isHovered
                ? "/img/bodyshop/right-arrow-white.svg"
                : "/img/bodyshop/black-blue-arrow.svg"
            }
          />
        </div>
      </div>
    </div>
  );
}

export default CaseStudiesCard;
